import { toast } from "react-toastify";

async function handle_api_error(error) {
  console.log('ERRRRRR12345===', error)
  const notify = (error) => {
    toast.error(`${error}`, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };
  try {
    if (error) {
      console.log("ERROR12", error)
      // Request made and server responded
      console.log(
        "=======Request made and server responded====",
        error
      );
      return notify(error);

      // return <ToastContainer />;
    } else if (error) {
      console.log(
        "========The request was made but no response =========== ",
        error
      );

      return notify(
        "An error occured while making the request. Kindly check your internet connection"
      );
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log("Error", error, error.err_msg);

      return error.err_msg;
    }
  } catch (err) {
    return err;
  }
}



export { handle_api_error };
